/**
 * Legacy redirect for /class-schedule/edit/:id links.
 *
 * The old route treated {id} sometimes as an OCCURRENCE id and sometimes as
 * a class TEMPLATE id, causing "Schedule not found". This component probes
 * GET /class-schedule/{id} (occurrence detail) and redirects:
 *   - occurrence found → /class-sessions/{id}/edit  (occurrence form)
 *   - not found        → /class-schedules/{id}/edit (template form)
 */
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useGetOneClassScheduleQuery } from "../../Api/attoDeskApi";

const ClassScheduleLegacyRedirect: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data, error, isLoading } = useGetOneClassScheduleQuery(id ?? "", { skip: !id });

  useEffect(() => {
    if (!id || isLoading) return;
    const isOccurrence = !!(data as any)?.data?.id;
    const status = (error as any)?.status;
    if (isOccurrence) {
      navigate(`/class-sessions/${id}/edit`, { replace: true });
    } else if (status === 404 || !isOccurrence) {
      navigate(`/class-schedules/${id}/edit`, { replace: true });
    }
  }, [id, data, error, isLoading, navigate]);

  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", py: 12 }}>
      <CircularProgress />
    </Box>
  );
};

export default ClassScheduleLegacyRedirect;
